import React, {Component} from 'react';
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import {connect} from "react-redux";

class RolesOptions extends Component {

  constructor(props) {
    super(props);

    this.state = {}
  }

  changeHandler(type, action, role) {
    this.props.onChange(type, action, role);
  }

  isRoleAvailable(role) {
    if (this.props.availableRoles) {
      return this.props.availableRoles.includes(role)
    }

    return true
  }

  render() {
    return (
      <div className="roles-options">
        <select className="form-control" value={''}
                onChange={(e) => this.changeHandler(this.props.type, this.props.action, e.target.value)}>
          <option value={''}>Add role</option>
          {this.isRoleAvailable('oit') ? <option value={'oit'}>{this.props.oitShortLabel}</option> : null}
          {this.isRoleAvailable('fto') ? <option value={'fto'}>{this.props.ftoShortLabel}</option> : null}
          {this.isRoleAvailable('ftoc') ? <option value={'ftoc'}>{this.props.ftocShortLabel}</option> : null}
          {this.isRoleAvailable('sup') ? <option value={'sup'}>{this.props.supShortLabel}</option> : null}
          {this.isRoleAvailable('cstaff') ? <option value={'cstaff'}>{this.props.cstaffShortLabel}</option> : null}
          {this.isRoleAvailable('chief') ? <option value={'chief'}>{this.props.chiefShortLabel}</option> : null}
        </select>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    ftocShortLabel: departmentSettingsSelectors.ftocShortLabel(state),
    supShortLabel: departmentSettingsSelectors.supShortLabel(state),
    cstaffShortLabel: departmentSettingsSelectors.cstaffShortLabel(state),
    chiefShortLabel: departmentSettingsSelectors.chiefShortLabel(state),
  }
};

export default connect(mapStateToProps)(RolesOptions);
